import Tool from '../../common/tool'
var index = 0
// 数据格式转换
function dataFormat(data, _this, idx) {
  // console.log(data)
  let option = null
  if (_this.$route.params.type === 0) {
    let selected = true

    let bjCountArray = Tool.sliceArrayByOrder(Tool.dictionaryToArray(data.bj_count), 12)
    if (idx >= bjCountArray.length || idx < 0) {
      return null
    }
    let bjCount = bjCountArray[idx]

    let CountArray = Tool.sliceArrayByOrder(Tool.dictionaryToArray(data.count), 12)
    if (idx >= CountArray.length || idx < 0) {
      return null
    }
    let Count = CountArray[idx]

    let keys = []
    let value1 = []
    let value2 = []
    for (var i = 0; i < bjCount.length; i++) {
      value1.push(bjCount[i].val)
      keys.push(bjCount[i].key)
    }

    for (var k = 0; k < Count.length; k++) {
      value2.push(Count[k].val)
      if (parseInt(Count[k].val) !== 0) {
        selected = false
      }
    }

    option = {
      legend_data: ['北京', _this.$route.params.name],
      legend_selected: { '北京': selected },
      ylabels: keys,
      series: [{
        name: '北京',
        type: 'bar',
        data: value1
      }, {
        name: _this.$route.params.name,
        type: 'bar',
        data: value2
      }]
    }
  } else {
    let CountArray = Tool.sliceArrayByOrder(Tool.dictionaryToArray(data.count), 12)
    if (idx >= CountArray.length || idx < 0) {
      return null
    }

    let Count = CountArray[idx]
    let keys = []
    let values = []

    for (var j = 0; j < Count.length; j++) {
      values.push(Count[j].val)
      keys.push(Count[j].key)
    }

    option = {
      legend_data: [_this.$route.params.name],
      legend_selected: { '北京': true },
      ylabels: keys,
      series: [{
        name: _this.$route.params.name,
        type: 'bar',
        data: values
      }]
    }
  }
  return option
}

// 设置
function setupOption(params) {
  const option = {
    backgroundColor: '#FFFFFF',
    color: ['#FF8000', '#66CCFF'],
    tooltip: {
      trigger: 'axis',
      axisPointer: { // 坐标轴指示器，坐标轴触发有效
        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
      }
    },
    legend: {
      data: params.legend_data,
      align: 'right',
      right: 10,
      selected: params.legend_selected
    },
    grid: {
      left: '2%',
      right: '4%',
      bottom: '32px',
      containLabel: true
    },
    yAxis: [{
      type: 'category',
      data: params.ylabels
    }],
    xAxis: [{
      type: 'value',
      axisLabel: {
        formatter: '{value}',
        rotate: 45
      },
      position: 'top'
    }],
    series: params.series
  }
  return option
}

// 导出选项
export function creatOption(data, _this) {
  index = 0
  let params = dataFormat(data, _this, index)
  if (params === null) {
    return null
  } else {
    return setupOption(params)
  }
}

export function nextChart(data, _this) {
  let params = dataFormat(data, _this, ++index)
  if (params === null) {
    --index
    return null
  } else {
    return setupOption(params)
  }
}

export function lastChart(data, _this) {
  let params = dataFormat(data, _this, --index)
  if (params === null) {
    ++index
    return null
  } else {
    return setupOption(params)
  }
}



// WEBPACK FOOTER //
// ./src/components/chartjs/CountChart.js